export default "__VITE_ASSET__DAeQhPuY__"